import { z } from "zod";

export const themePreferences = ["light", "dark", "system"] as const;
export type ThemePreference = (typeof themePreferences)[number];

export const resolvedThemes = ["light", "dark"] as const;
export type ResolvedTheme = (typeof resolvedThemes)[number];

const themePreferenceSchema = z.enum(themePreferences);

export const THEME_STORAGE_KEY = "theme";

export const getSystemColorScheme = (): ResolvedTheme => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return "light";
  }
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};

/**
 * Two-state toggle next preference (Lea Verou):
 * flip the resolved appearance; store a literal override only when it differs
 * from the system preference, otherwise clear back to system.
 */
export const getNextThemePreference = (params: {
  resolved: ResolvedTheme;
  system: ResolvedTheme;
}): ThemePreference => {
  const target = params.resolved === "light" ? "dark" : "light";
  return target === params.system ? "system" : target;
};

export const getThemePreference = (): ThemePreference => {
  const result = themePreferenceSchema.safeParse(localStorage.getItem(THEME_STORAGE_KEY));
  return result.success ? result.data : "system";
};

export const persistThemePreference = (value: ThemePreference) => {
  if (value === "system") {
    localStorage.removeItem(THEME_STORAGE_KEY);
    return;
  }
  localStorage.setItem(THEME_STORAGE_KEY, value);
};
